import React from 'react'
import { Router } from 'react-router'
import { node, string } from 'prop-types'
import { createMemoryHistory } from 'history'
import FlowStep from './FlowStep'

export default class PageFlow extends React.PureComponent {
  constructor(props) {
    super(props)
    this.history = createMemoryHistory()
    this.updateCurrentRoute()
  }

  static propTypes = {
    children: node.isRequired,
    currentStep: string.isRequired
  }

  static Step = FlowStep

  componentDidUpdate = previousProps =>
    previousProps.currentStep !== this.props.currentStep
      ? this.updateCurrentRoute()
      : null

  updateCurrentRoute = () =>
    this.props.currentStep && this.history.push(`/${this.props.currentStep}`)

  render = () => (
    <Router history={this.history}>
      <React.Fragment>{this.props.children}</React.Fragment>
    </Router>
  )
}
